import axios from "axios";
import https from "https";

export const BASE_URL = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api`;
// export const BASE_URL = `https://dev.finansfabriken.se/api`;
// export const BASE_URL = `/api`;

const isServer = typeof window === "undefined";

export const AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json"
  },
  ...(isServer && {
    httpsAgent: new https.Agent({ rejectUnauthorized: false })
  })
});

const callAPI = async ({ url, method, headers = {}, data = {}, params = {} }) => {
  try {
    const response = await AxiosInstance({
      url,
      method,
      headers,
      data: JSON.stringify(data),
      params
    });

    return response.data;
  } catch (error) {
    console.log("API Request Error:", error?.response || error);
    throw error;
  }
};

export default callAPI;
